import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import jobTasks from './modules/jobTasks'
import loadingIndicator from "./modules/loadingIndicator"
import user from './modules/user'
import role from './modules/role'
import account from './modules/account'
import routes from './modules/routes'
import tags from './modules/tags'
import planning from "./modules/planning";
import imports from './modules/import'

import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
const store = new Vuex.Store({
    modules: {
        auth,
        loadingIndicator,
        user,
        jobTasks,
        role,
        routes,
        account,
        tags,
        imports,
        planning
    },
    plugins: [createPersistedState()]
})

export default store
